import {
  Box,
  CircularProgress,
  FormControl,
  MenuItem,
  TextField,
  Typography
} from '@mui/material';
import PressReleaseCard from './Sections/PressReleaseCard';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { usePressReleasesData } from './usePressReleaseData';

const PressRelease = () => {
  const [year, setYear] = useState('all');

  const releasesList = usePressReleasesData();

  return (
    <>
      <Helmet>
        <title>Press releases</title>
      </Helmet>
      <Typography variant="h1" sx={{ mt: 12, mb: 6 }}>
        Discover our press releases
      </Typography>

      {releasesList === undefined ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            my: 3,
            height: '70vh'
          }}
        >
          <CircularProgress />
        </Box>
      ) : releasesList?.length ? (
        <>
          <FormControl sx={{ width: '120px' }}>
            <TextField
              select
              label="Select year"
              onChange={option => setYear(option?.target?.value ?? 'all')}
              value={year}
              sx={{ background: 'white', borderColor: 'transparent' }}
            >
              {[
                'all',
                ...[...new Set(releasesList.map(r => r.year))].sort(
                  (a, b) => b - a
                )
              ].map(year => (
                <MenuItem key={year} value={year.toString()}>
                  {year === 'all' ? 'All Years' : year}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
          <Box
            sx={{ display: 'flex', flexDirection: 'column', gap: 3, my: 10 }}
          >
            {releasesList
              .filter(
                release => year === 'all' || release.year.toString() === year
              )
              .map(release => (
                <PressReleaseCard
                  key={release.date + release.title}
                  release={release}
                />
              ))}
          </Box>
        </>
      ) : (
        <Typography sx={{ mb: 5 }}>No press releases found.</Typography>
      )}
    </>
  );
};

export default PressRelease;

export interface ReleaseProps {
  date: string;
  year: number;
  title: string;
  description: string;
  file: {
    link: string;
    size?: string;
  };
}
